const ID_TOKEN_KEY = "id_token";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 14;

let memoryToken = null;

function decodePayload(token) {
    const parts = String(token).split(".");
    if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) {
        return null;
    }

    try {
        const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
        const json = decodeURIComponent(
            atob(padded)
                .split("")
                .map(char => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        const payload = JSON.parse(json);
        return payload && typeof payload === "object" ? payload : null;
    } catch (e) {
        return null;
    }
}

export function isWellFormedToken(token) {
    return typeof token === "string" && token.length > 0 && decodePayload(token) !== null;
}

function readLocalToken() {
    try {
        return window.localStorage.getItem(ID_TOKEN_KEY);
    } catch (e) {
        return undefined;
    }
}

function writeLocalToken(token) {
    try {
        window.localStorage.setItem(ID_TOKEN_KEY, token);
        return true;
    } catch (e) {
        return false;
    }
}

function readCookieToken() {
    try {
        const prefix = ID_TOKEN_KEY + "=";
        const parts = document.cookie ? document.cookie.split("; ") : [];
        for (let i = 0; i < parts.length; i++) {
            if (parts[i].indexOf(prefix) === 0) {
                return decodeURIComponent(parts[i].slice(prefix.length));
            }
        }
    } catch (e) {
        return null;
    }

    return null;
}

function writeCookieToken(token) {
    try {
        const secure = window.location.protocol === "https:" ? "; Secure" : "";
        document.cookie = ID_TOKEN_KEY + "=" + encodeURIComponent(token)
            + "; Path=/; Max-Age=" + COOKIE_MAX_AGE_SECONDS
            + "; SameSite=Lax" + secure;
    } catch (e) {
        // Cookie storage can be blocked; localStorage still holds the session.
    }
}

function clearCookieToken() {
    try {
        const secure = window.location.protocol === "https:" ? "; Secure" : "";
        document.cookie = ID_TOKEN_KEY + "=; Path=/; Max-Age=0; SameSite=Lax" + secure;
    } catch (e) {
        // Ignore.
    }
}

export const getToken = () => {
    const stored = readLocalToken();
    const cookie = readCookieToken();

    if (isWellFormedToken(stored)) {
        memoryToken = stored;
        if (cookie !== stored) {
            writeCookieToken(stored);
        }
        return stored;
    }

    if (isWellFormedToken(cookie)) {
        memoryToken = cookie;
        writeLocalToken(cookie);
        return cookie;
    }

    if (isWellFormedToken(memoryToken)) {
        return memoryToken;
    }

    return null;
};

export const saveToken = token => {
    if (!isWellFormedToken(token)) {
        return;
    }

    memoryToken = token;
    writeLocalToken(token);
    writeCookieToken(token);
};

export const destroyToken = () => {
    memoryToken = null;
    try {
        window.localStorage.removeItem(ID_TOKEN_KEY);
    } catch (e) {
        // Ignore storage failures on logout.
    }
    clearCookieToken();
};

export default { getToken, saveToken, destroyToken, isWellFormedToken };
